import { render, staticRenderFns } from "./VehicleQuickSummary.vue?vue&type=template&id=6b5ee9e7&lang=pug&"
import script from "./VehicleQuickSummary.vue?vue&type=script&lang=ts&"
export * from "./VehicleQuickSummary.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleQuickSummary.vue?vue&type=style&index=0&id=6b5ee9e7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports